import { useState } from 'react';
import { Link } from 'react-router-dom';
import MediaCard from '@/components/feature/MediaCard';
import { getHotMedia } from '@/utils/media';

export default function HotSection() {
  const [tab, setTab] = useState<'movie' | 'tv'>('movie');
  const items = getHotMedia(6, tab);

  return (
    <section className="animate-fade-up">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-600">
            <i className="ri-fire-line text-lg"></i>
          </span>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">热门推荐</h2>
          <span className="hidden text-xs text-foreground-500 sm:block">按点击热度精选</span>
        </div>
        <div className="flex items-center gap-1 rounded-full bg-background-100 p-1">
          <Link
            to="/category/movie"
            onClick={() => setTab('movie')}
            className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
              tab === 'movie' ? 'bg-accent-500 text-background-50' : 'text-foreground-600 hover:text-foreground-900'
            }`}
          >
            热门电影
          </Link>
          <Link
            to="/category/tv"
            onClick={() => setTab('tv')}
            className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
              tab === 'tv' ? 'bg-accent-500 text-background-50' : 'text-foreground-600 hover:text-foreground-900'
            }`}
          >
            热播剧集
          </Link>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4">
        {items.map((item) => (
          <MediaCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}